import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Maintenance from './maintenance/Maintenance';
import Thanks from './Thanks';
import Dashboard from './Dashboard';
import Privacy from './Privacy';

import TagManager from 'react-gtm-module';
import GTMRouteTracker from './GTMRouteTracker';

const tagManagerArgs = {
  gtmId: 'GTM-NHXTGXZZ'
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <GTMRouteTracker />
      <Routes>
        <Route path="/" element={<Maintenance />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/thanks" element={<Thanks />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </Router>
  </React.StrictMode>
  //checking maintenance
);
